"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./..");

var _Icons = require("../Icons");

var _TrashCan = _interopRequireDefault(require("../Icons/TrashCan"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _StyledFlex = (0, _styledComponents["default"])(_.Flex).withConfig({
  displayName: "AttentionSpanGridRow___StyledFlex",
  componentId: "sc-1dhtj15-0"
})(["background-color:rgb(32,42,61);position:absolute;height:70px;padding-left:10px;width:", ";z-index:1;"], function (p) {
  return p._css;
});

var _StyledFlex2 = (0, _styledComponents["default"])(_.Flex).withConfig({
  displayName: "AttentionSpanGridRow___StyledFlex2",
  componentId: "sc-1dhtj15-1"
})(["color:#fff;position:relative;width:20px;width:20px;text-align:center;"]);

var _StyledPencilUnderline = (0, _styledComponents["default"])(_Icons.PencilUnderline).withConfig({
  displayName: "AttentionSpanGridRow___StyledPencilUnderline",
  componentId: "sc-1dhtj15-2"
})(["cursor:pointer;"]);

var _StyledTrashCan = (0, _styledComponents["default"])(_TrashCan["default"]).withConfig({
  displayName: "AttentionSpanGridRow___StyledTrashCan",
  componentId: "sc-1dhtj15-3"
})(["cursor:pointer;"]);

var _StyledSpan = (0, _styledComponents["default"])("span").withConfig({
  displayName: "AttentionSpanGridRow___StyledSpan",
  componentId: "sc-1dhtj15-4"
})(["width:10px;height:20px;margin-right:5px;color:#fff;"]);

var _StyledFlex3 = (0, _styledComponents["default"])(_.Flex).withConfig({
  displayName: "AttentionSpanGridRow___StyledFlex3",
  componentId: "sc-1dhtj15-5"
})(["margin-left:", ";border:1px solid rgba(0,0,0,0.4);box-sizing:border-box;position:relative;height:70px;"], function (p) {
  return p._css2;
});

var _StyledFlex4 = (0, _styledComponents["default"])(_.Flex).withConfig({
  displayName: "AttentionSpanGridRow___StyledFlex4",
  componentId: "sc-1dhtj15-6"
})(["box-sizing:border-box;border-right:1px solid rgba(0,0,0,0.4);&:last{border-right:none;}"]);

var _StyledDiv = (0, _styledComponents["default"])("div").withConfig({
  displayName: "AttentionSpanGridRow___StyledDiv",
  componentId: "sc-1dhtj15-7"
})(["position:absolute;top:0;bottom:0;left:", "%;width:", "%;&:before{content:' ';position:absolute;top:1px;right:1px;bottom:1px;left:1px;border-top-left-radius:", ";border-bottom-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";background-image:", ";background-color:", ";border:", ";}"], function (_ref) {
  var leftSpacing = _ref.leftSpacing;
  return leftSpacing;
}, function (_ref2) {
  var totalWidth = _ref2.totalWidth;
  return totalWidth;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
}, function (_ref3) {
  var id = _ref3.id;
  return !id && 'repeating-linear-gradient(135deg,#4E74FC,#4E74FC 1px,#6885ea8f 1px,#6885ea8f 10px)';
}, function (_ref4) {
  var id = _ref4.id;
  return id && '#4E74FC';
}, function (_ref5) {
  var id = _ref5.id;
  return !id && '1px solid #4E74FC';
});

var _StyledDiv2 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "AttentionSpanGridRow___StyledDiv2",
  componentId: "sc-1dhtj15-8"
})(["position:absolute;top:10px;left:10px;font-size:10px;color:white;"]);

var _StyledPencilUnderline2 = (0, _styledComponents["default"])(_Icons.PencilUnderline).withConfig({
  displayName: "AttentionSpanGridRow___StyledPencilUnderline2",
  componentId: "sc-1dhtj15-9"
})(["position:absolute;bottom:5px;right:5px;width:15px;height:30px;color:white;cursor:pointer;"]);

var _StyledCross = (0, _styledComponents["default"])(_Icons.Cross).withConfig({
  displayName: "AttentionSpanGridRow___StyledCross",
  componentId: "sc-1dhtj15-10"
})(["position:absolute;top:10px;right:5px;width:12px;color:white;cursor:pointer;"]);

var AttentionSpanGridRow = function AttentionSpanGridRow(_ref6) {
  var className = _ref6.className,
      spaceId = _ref6.id,
      tagElement = _ref6.tagElement,
      attentionSpans = _ref6.attentionSpans,
      onEditSpace = _ref6.onEditSpace,
      onDeleteSpace = _ref6.onDeleteSpace,
      load = _ref6.load,
      unload = _ref6.unload,
      loadUnload = _ref6.loadUnload,
      onCreateWindow = _ref6.onCreateWindow,
      onDeleteWindow = _ref6.onDeleteWindow,
      onEditWindow = _ref6.onEditWindow,
      _ref6$compact = _ref6.compact,
      compact = _ref6$compact === void 0 ? false : _ref6$compact,
      _ref6$editable = _ref6.editable,
      editable = _ref6$editable === void 0 ? true : _ref6$editable;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHeaderHovered = _useState2[0],
      setIsHeaderHovered = _useState2[1];

  var editSpace = function editSpace() {
    if (onEditSpace) onEditSpace(spaceId);
  };

  var deleteSpace = function deleteSpace() {
    if (onDeleteSpace) onDeleteSpace(spaceId);
  };

  var createWindow = function createWindow(position) {
    return function () {
      if (onCreateWindow) onCreateWindow(spaceId, position);
    };
  };

  var deleteWindow = function deleteWindow(windowId) {
    if (onDeleteWindow) {
      onDeleteWindow(windowId);
    }
  };

  var editWindow = function editWindow(windowId) {
    if (onEditWindow) {
      onEditWindow(windowId);
    }
  };

  var loadIcons = [{
    Icon: _Icons.ArrowUp,
    isShown: load
  }, {
    Icon: _Icons.ArrowDown,
    isShown: unload
  }, {
    Icon: _Icons.ArrowUpDown,
    isShown: loadUnload
  }].filter(function (_ref7) {
    var isShown = _ref7.isShown;
    return isShown;
  }); // const firstTag = tagList.length > 0 ? tagList[0] : null
  // const restTags = tagList.length > 1 ? tagList.slice(1) : null

  return /*#__PURE__*/_react["default"].createElement(_.Flex, {
    container: true,
    className: "".concat(className, " attention-span-grid-row")
  }, /*#__PURE__*/_react["default"].createElement(_StyledFlex, {
    shrink: true,
    container: true,
    align: "center",
    onMouseEnter: function onMouseEnter() {
      return setIsHeaderHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHeaderHovered(false);
    },
    _css: compact ? '25px;' : '125px;'
  }, /*#__PURE__*/_react["default"].createElement(_StyledFlex2, {
    shrink: true
  }, isHeaderHovered && editable ? /*#__PURE__*/_react["default"].createElement(_.Flex, {
    direction: "row"
  }, onEditSpace ? /*#__PURE__*/_react["default"].createElement(_StyledPencilUnderline, {
    onClick: editSpace
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), onDeleteSpace ? /*#__PURE__*/_react["default"].createElement(_StyledTrashCan, {
    onClick: deleteSpace
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)) : spaceId), compact ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement(_.Flex, {
    col: "auto",
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_.Flex, {
    container: true,
    justify: "center"
  }, loadIcons.map(function (_ref8, index) {
    var Icon = _ref8.Icon;
    return /*#__PURE__*/_react["default"].createElement(_StyledSpan, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(Icon, null));
  })), tagElement)), /*#__PURE__*/_react["default"].createElement(_StyledFlex3, {
    container: true,
    col: "auto",
    _css2: compact ? '35px;' : '135px;'
  }, Array.from(Array(24).keys()).map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_StyledFlex4, {
      key: item,
      col: "auto",
      onClick: createWindow(item)
    });
  }), attentionSpans.map(function (_ref9, index) {
    var id = _ref9.id,
        startTime = _ref9.startTime,
        endTime = _ref9.endTime,
        first_day = _ref9.first_day;
    var stTime = parseInt(startTime / 100) * 100 + startTime % 100 * 100 / 60;
    var edTime = parseInt(endTime / 100) * 100 + endTime % 100 * 100 / 60;
    var leftSpacing = stTime * 100 / 2400;
    var rightSpacing = edTime * 100 / 2400; // const leftSpacing = (startTime * 100) / 2400
    // const rightSpacing = (endTime * 100) / 2400

    var times = ["".concat('0000'.concat(startTime).substr(-4, 4)), "".concat(endTime)].map(function (time) {
      return time ? "".concat(time.slice(0, time.length === 4 ? 2 : 1), ":").concat(time.slice(time.length === 4 ? 2 : 1)) : null;
    }).filter(function (item) {
      return item;
    }).join(' - ');
    return /*#__PURE__*/_react["default"].createElement(_StyledDiv, {
      leftSpacing: leftSpacing,
      totalWidth: rightSpacing - leftSpacing,
      key: index,
      id: id,
      _css3: first_day !== undefined ? first_day ? '5px' : '0px' : '5px',
      _css4: first_day !== undefined ? first_day ? '5px' : '0px' : '5px',
      _css5: first_day !== undefined ? first_day ? '0px' : '5px' : '5px',
      _css6: first_day !== undefined ? first_day ? '0px' : '5px' : '5px'
    }, /*#__PURE__*/_react["default"].createElement(_StyledDiv2, null, times), id && onEditWindow ? /*#__PURE__*/_react["default"].createElement(_StyledPencilUnderline2, {
      onClick: function onClick() {
        return editWindow(id);
      }
    }) : null, onDeleteWindow ? /*#__PURE__*/_react["default"].createElement(_StyledCross, {
      onClick: function onClick() {
        return deleteWindow(id);
      }
    }) : null);
  })));
};

AttentionSpanGridRow.defaultProps = {
  attentionSpans: [],
  tagList: []
};
AttentionSpanGridRow.propTypes = {
  /** Listado de ventanas de atención cada una corresponde a una ventana de atención dentro de la fila. */
  attentionSpans: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /** numero identificador de la ventana de atención */
    id: _propTypes["default"].number,

    /** date indica la hora de inicio de la ventana ( hora y minutos) */
    startTime: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /** date indica la hora de fin de la ventana */
    endTime: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  })),

  /** Nombre de la clase que se concatena al elemento raíz */
  className: _propTypes["default"].string,

  /** Numero identificador de la fila, no tiene relación con el numero que se presenta en el encabezado de fila. */
  id: _propTypes["default"].number,
  // /** Indica los elementos de etiquetas para el encabezado. */
  // tagList: PropTypes.array,

  /** Se detona al dar click en el icono de edición del encabezado de fila */
  onEditSpace: _propTypes["default"].func,

  /** Se detona al dar click en el icono de eliminar del encabezado de fila */
  onDeleteSpace: _propTypes["default"].func,

  /** Indica si se muestra el icono de carga en el encabezado de la fila. */
  load: _propTypes["default"].bool,

  /** Indica si se muestra el icono de descarga en el encabezado de la fila. */
  unload: _propTypes["default"].bool,

  /** Indica si se muestra el icono de carga y descarga en el encabezado de la fila. */
  loadUnload: _propTypes["default"].bool,

  /** Se ejecuta al dar click en cualquier espacio libre de la fila */
  onCreateWindow: _propTypes["default"].func,

  /** Se detona al hacer click sobre la x en una ventana existente. */
  onDeleteWindow: _propTypes["default"].func,

  /** Se ejecuta al dar click sobre el icono de edición de una ventana de atención. */
  onEditWindow: _propTypes["default"].func,

  /** Indica que la fila debe mostrarse en modo compacto */
  compact: _propTypes["default"].bool,

  /** Indica que la fila debe mostrarse en modo compacto */
  editable: _propTypes["default"].bool,

  /** Elemento que muestra las etiquetas para el encabezado. */
  tagElement: _propTypes["default"].element
};
var _default = AttentionSpanGridRow;
exports["default"] = _default;